import React, {useContext, useRef} from 'react'
import * as XLSX from 'xlsx'
import { 
  POSTCODE_IMPORT_POSTCODE,
  IMPORT_INITIAL_PROGRESS
} from '../../../../../../common/constant'
import {
  transformPostCodeSaveJson
} from './transformer'
import {savePostCode, getImportPostCodeProgress} from '../../../../../../api/post-code-api'
import {AdminContext} from '../../../../../../context/AdminContext'

const UploadPostCode = () => {
  const {setPostCodeMessage, isPostCodeUploading, setIsPostCodeUploading, pollPostCodeProgress, stopPostCodeProgress, setPostCodeProgress} =
    useContext(AdminContext)
  const fileInputRef = useRef<any>(null)

  const handleFileChange = (e: any) => {
    const file = e.target.files[0]

    if (
      file &&
      (file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    ) {
      setIsPostCodeUploading(true)
      convertExcelToJson(file)
        .then((jsonData) => {
          setPostCodeProgress(IMPORT_INITIAL_PROGRESS)
          handleUpload(jsonData)
        })
        .catch((error) => {
          setIsPostCodeUploading(false)
          setPostCodeProgress()
          setPostCodeMessage({
            isSuccess: false,
            message: error,
          })
        })
    } else {
      setPostCodeMessage({
        isSuccess: false,
        message: 'Please upload a valid Excel file (XLS or XLSX).',
      })

      e.target.value = null
      stopPostCodeProgress()
    }
  }

  const convertExcelToJson = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = (e: any) => {
        try {
          const data = e.target.result
          const workbook = XLSX.read(data, {type: 'binary'}) as any
          const jsonData = {} as any

          if (workbook.SheetNames.length < 1) {
            reject('Please upload a valid post code import file.')
            return
          }

          workbook.SheetNames.forEach((sheetName: any) => {
            var xlsJson: any = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {header: 1})
            jsonData[POSTCODE_IMPORT_POSTCODE] = transformPostCodeSaveJson(xlsJson)
          })

          resolve(jsonData)
        } catch (error) {
          reject(error)
        }
      }

      reader.readAsBinaryString(file)
    })
  }

  const handleButtonClick = () => {
    fileInputRef.current?.click()
  }

  const handleUpload = (jsonData: any) => {
    savePostCode(jsonData)
      .then((result: any) => {
        if (result.status === 409) {
          setPostCodeMessage({
            isSuccess: false,
            message: 'An import is already in progress. Please wait for it to complete.',
          })
        } else if (result.data) {
          const taskId = result.data
          pollPostCodeProgress(taskId)
        } else {
          setPostCodeMessage({
            isSuccess: false,
            message: 'Failed to Upload Post Code list',
          })
          stopPostCodeProgress()

          setIsPostCodeUploading(false)
        }
      })
      .catch(() => {
        setIsPostCodeUploading(false)
        stopPostCodeProgress()
        setPostCodeMessage({
          isSuccess: false,
          message: 'Failed to Upload Post Code List',
        })
      })
  }

  return (
    <div>
      <input
        type='file'
        accept='.xls, .xlsx'
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{display: 'none'}}
        disabled={isPostCodeUploading}
      />
      <button disabled={isPostCodeUploading} type='button' className='btn btn-primary' onClick={handleButtonClick}>
        IMPORT
      </button>
    </div>
  )
}

export default UploadPostCode
